import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
import NetflixApp from "../../img/netflixApp.JPG";
import AmazonApp from "../../img/amazonApp.JPG";
import HOC from "../../img/hoc.png";
import CryptoTracker from "../../img/cryptoTracker.JPG";
import { themeContext } from "../../Context";
const Portfolio = () => {
 
  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span>Personal Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={20}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
      >
        <SwiperSlide>
          <a href="https://netflix-clone-f3263.web.app/" target="_blank"><img style={{cursor:"pointer"}}  src={NetflixApp} alt="" /></a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://clone1-dfec6.web.app/" target="_blank"><img style={{cursor:"pointer"}}  src={AmazonApp} alt="" /></a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://leafy-biscotti-9d2dce.netlify.app/" target="_blank" ><img style={{cursor:"pointer"}} src={CryptoTracker} alt="" /></a>
        </SwiperSlide>
        {/* <SwiperSlide>
          <img src={HOC} alt="" />
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
};

export default Portfolio;
